export default __webpack_public_path__ + "static/media/NF.d0322f4d.svg";